import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { ErrorMessages } from '../../utility/constants';

@Component({
  selector: 'app-summary-table',
  standalone: true,
  imports: [CommonModule, MaterialModule, SvgIconComponent],
  templateUrl: './summary-table.component.html',
  styleUrl: './summary-table.component.scss',
})
export class SummaryTableComponent {
  @Input() tableData: any[] = [];
  @Input() noDataMessage: string = ErrorMessages.noData;
  @Input() columnDefs: { key: string; label: string }[] = [];
  @Input() showActionButton: boolean = false;
  @Input() actionButtonLabel: string = 'Proceed';
  @Input() isFrom!: string;
  @Input() disableActions: boolean = false;
  @Output() hyperlinkClicked = new EventEmitter<{
    columnKey: string;
    rowData: any;
  }>();

  @Output() actionClicked = new EventEmitter<any>();
  @Output() airwayActionClicked = new EventEmitter<any>();

  get displayedColumns(): string[] {
    const cols = this.columnDefs.map(col => col.key);
    return this.showActionButton ? [...cols, 'action'] : cols;
  }

  public onActionClick(row: any): void {
    this.actionClicked.emit(row);
  }

  public onAirwayActionClick(row: any, action: string): void {
    if (this.disableActions) {
      return;
    }
    this.airwayActionClicked.emit({
      data: row,
      action: action,
      isFrom: this.isFrom,
    });
  }

  public alignKeyText(key: string): boolean {
    const keys = ['Unit Value', 'Quantity', 'Weight', 'Value'];
    return keys.includes(key);
  }

  public identifyHyperLinks(label: string): boolean {
    const keys = ['trackLink', 'commercialInvoice', 'airWaybills'];
    return keys.includes(label);
  }

  public onHyperlinkClick(columnKey: string, rowData: any): void {
    this.hyperlinkClicked.emit({ columnKey, rowData });
  }

  public shouldShowMasterShipment(columnKey: string, element: any): boolean {
    return columnKey === 'shipment' && element.isMaster;
  }
}
